// extracted by mini-css-extract-plugin
export var card = "_jk-5";
export var cardSelected = "_jk-4";
export var image = "_jk-3";
export var modal = "_jk-0";
export var modalContent = "_jk-1";
export var table = "_jk-2";